import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'

function Services() {
    const services = [
        {
            icon: 'icon-service-1.svg',
            title: 'Online Co-operative Platform',
            desc: 'Join our digital co-operative for collective financial growth through savings, investments, and affordable loans.',
            link: '/service-cooperative',
            delay: '0s',
        },
        {
            icon: 'icon-service-2.svg',
            title: 'Micro-Lending Services',
            desc: 'Accessible financing solutions for individuals and small businesses to bridge financial gaps.',
            link: '/service-micro-lending',
            delay: '0.2s',
        },
        {
            icon: 'icon-service-3.svg',
            title: 'Tax Consulting Services',
            desc: 'Comprehensive tax advisory and compliance services to minimize liabilities and ensure regulation adherence.',
            link: '/service-tax-consulting',
            delay: '0.4s',
        },
        {
            icon: 'icon-service-4.svg',
            title: 'Financial Reporting & Analysis',
            desc: 'Transform financial data into actionable insights for informed business decisions and growth opportunities.',
            link: '/service-financial-reporting',
            delay: '0.6s',
        },
    ]

    return (
        <>
            <PageHeader title="Our services" />

            <div className="page-services">
                <div className="container">
                    <div className="row">
                        {services.map((service, idx) => (
                            <div className="col-lg-4 col-md-6" key={idx}>
                                <div
                                    className="service-item wow fadeInUp"
                                    data-wow-delay={service.delay}
                                >
                                    <div className="icon-box">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/${service.icon}`}
                                            alt=""
                                        />
                                    </div>
                                    <div className="service-item-content">
                                        <h3>{service.title}</h3>
                                        <p>{service.desc}</p>
                                        <Link
                                            to={service.link}
                                            className="service-btn"
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/arrow-white.svg`}
                                                alt=""
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="why-choose-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="why-choose-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">
                                        why choose us
                                    </h3>
                                    <h2
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        Why trust us <span>our finances</span>
                                    </h2>
                                </div>
                                <div className="why-choose-box-list">
                                    <div
                                        className="why-choose-box wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/icon-why-choose-1.svg`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="why-choose-box-content">
                                            <h3>Local Expertise</h3>
                                            <p>
                                                Combining deep knowledge of
                                                Nigeria's financial landscape
                                                with international best
                                                practices.
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="why-choose-box wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/icon-why-choose-2.svg`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="why-choose-box-content">
                                            <h3>Technology-Driven</h3>
                                            <p>
                                                24/7 access through secure
                                                platforms with bank-grade
                                                encryption and data protection.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="why-choose-list wow fadeInUp"
                                    data-wow-delay="0.4s"
                                >
                                    <ul>
                                        <li>Financial Inclusion Focus</li>
                                        <li>Regulatory Compliance</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-choose-image">
                                <div className="why-choose-img-1">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/why-choose-img-1.jpg`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="why-choose-img-2">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/why-choose-img-2.jpg`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="why-choose-contact-circle">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/contact-us-img.svg`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Services
